import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 7V0H9V7H16V9H9V16H7V9H9.53674e-07V7H7Z", fill: "white" }));
export default SvgPlus;
